import styled from 'styled-components/macro';

export default styled('div')`
  display: flex;
  flex-direction: row;
  margin-left: -15px;
  margin-right: -15px;
`;
